import { apiRequest } from '@/api/client'
import type { Session } from '@/types/auth'

// The one place the login call is made; PRD 09's Access screen calls this,
// nothing else does. This request is unauthenticated (no token exists yet) -
// its own 401 (GUI_AUTH_002_LOGIN_FAILED) is a different error code than a
// protected route's GUI_AUTH_001_INVALID_TOKEN, so it never triggers the
// global redirect-to-/access handler (see src/lib/queryClient.tsx).
export function login(credentials: { email: string; password: string }): Promise<Session> {
  return apiRequest<Session>('/gui/v1/auth/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  })
}
